import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import introJs from 'intro.js';
import { ThemeService } from 'src/app/core/services/theme.service';
import { TokenStorageService } from 'src/app/core/services/token-storage.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {
  userId = JSON.parse(localStorage.getItem('usuarioId') || '{}');
  userName = JSON.parse(localStorage.getItem('userName') || '{}');
  isDark = false;
  textMode = '';
  constructor(
    private tokenService: TokenStorageService,
    private router: Router,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    // this.isDark = this.themeService.isDarkMode();
    // this.textMode=this.isDark ? 'Modo Claro' : 'Modo Oscuro';
  }

  confirmLogout() {
    this.tokenService.signOut();
    this.router.navigate(['/login']);
  }

  // toggleTheme() {
  //   this.themeService.toggle();
  //   this.isDark = this.themeService.isDarkMode();
  //   this.textMode=this.isDark ? 'Modo Claro' : 'Modo Oscuro';
  // }
  iniciarTour() {
    introJs().setOptions({
      steps: [
        {
          element: '#clientes',
          intro: 'Aquí podés administrar tus clientes, ver sus deudas y pagos, editar, eliminar.',
          title: 'Información de Clientes',
        },
        {
          element: '#productos',
          intro: 'Aquí podés gestionar los productos: agregar, editar, eliminar y ver el stock.',
          title: 'Información de Productos',
        },
        {
          element: '#menu',
          intro: 'Aquí podés acceder a tu perfil, cerrar sesión y cambiar la contraseña.',
          title: 'Menu de Usuario',
        },
      ],
      showProgress: true,
      showBullets: false,
      nextLabel: 'Siguiente',
      prevLabel: 'Anterior',
      doneLabel: 'Finalizar'
    }).start();
  }

  empezarGuia() {
    this.iniciarTour();
  }
}
